export default {
  key: "cp_request",
  trash: false,
  type: "readonly",
  id: "req_id",
  export: ["excel"],
  excel: {
    //max_row: "50000" 
  },
  sort: {
    field: "req_id",
    order: "desc"
  },
  sort_fields: [
    "req_id",
    // "cp_no",
    "request_type",
    "session_id",
      "tran_id",
    "cre_dttm",
      "rsr_id"
  ],
  filters: {
    req_id: {},
    rsr_id: {},
    request_type: {
      type: "multiselect",
      label: "request_type",
      value: "name_chi",
      default: [1,2,3,4,5,7,8,9,10,14,15,16,17]
    },
    // cp_name: {},
    cre_dttm: {
      type: "daterange"
    },
    session_id: {},
    tran_id: {},
    cp_id:{
      type: "select",
      filterable: true},
    cp_no: {
      type: "multiselect",
      filterable: true
      // label: "cp_no",
      // value: "cp_id",
    },
    connector_id:{
      // type: "multiselect",
      // filterable: true
    },
  },
  options: {
    request_type: {
      key: "request_types",
      label: "name_chi",
      value: "request_type"
    },
    cp_no: {
      key: "cps",
      label: "cp_no",
      value: "cp_no",
    },
    cp_id: {
      key: "cps",
      label: "cp_no",
      value: "cp_id",
    }
  },
  fields: [
    { key: "req_id", width: 100},
    { key: "charge_box_serial_number", field: "cp_id.charge_box_serial_number" },
    { key: "cp_id", field: "cp_id.cp_no"},
    { key: "connector_id"},
    {key: "connectorStatus"},
    // { key: "cp_name", field: "cp_id.name"},
    { key: "request_type", field: "request_type.name_chi" },
    { key: "request_data", hidden: ["list"] },
    { key: "response_data", hidden: ["list"] },
    { key: "cre_dttm", type: "datetime" },
    { key: "session_id", field: "session_id.session_id" },
    { key: "tran_id"},
    { key: "rsr_id", privilege:["cstDebug"]},
    { type: "action-btn", width: 50 },
    { key: "uuid", hidden: ["list"]},
  ],
  action: ["view"],
  view: [
    ["req_id", { key: "cp_no", value: "cp_id.cp_no" }],
    [{ key: "cre_dttm", type: "datetime" }, { key: "request_type", value: "request_type.name_chi" }],
    [{ key: "cp_name", value: "cp_id.name" }, { key: "loc", value: "cp_id.loc_id.address_chi" }],
    [{ key: "firmware_version", value: "cp_id.firmware_version" }],
    ["uuid"],
    ["request_data"],
    ["response_data"],

  ]
}